module.exports = __webpack_public_path__ + "img/index_score.982b8a42.png";